// extracted by mini-css-extract-plugin
export default {"audio_player":"AudioPlayer_audio_player__HZzlz","divider":"AudioPlayer_divider__1zV1c"};